import { Dutch } from "flatpickr/dist/l10n/nl.js"

const periodSelectorEl = document.querySelector('.js-booking-payout-period');

if (periodSelectorEl) {
    var today = new Date();
    today.setMonth(today.getMonth() - 1);

    flatpickr(periodSelectorEl, {
        mode: "range",
        dateFormat: "d-m-Y",
        locale: Dutch,
        onChange: function (selectedDates, dateStr, instance) {
            if (selectedDates.length > 0) {
                let startDate = selectedDates[0];
                let maxDate = new Date(startDate);
                maxDate.setMonth(maxDate.getMonth() + 1);

                instance.set("maxDate", maxDate);
            }
        },
    });
}

const pieChartSegmentEls = document.querySelectorAll('.segment-label');

if (pieChartSegmentEls) {
    pieChartSegmentEls.forEach(label => {
        const angle = parseFloat(label.dataset.angle);
        const radius = 60;
        const radians = (angle - 25) * Math.PI / 50;
        const x = 110 + radius * Math.cos(radians)
        const y = 110 + radius * Math.sin(radians);

        label.style.position = 'absolute';
        label.style.left = `${x}px`;
        label.style.top = `${y}px`;
        label.style.transform = 'translate(-50%, -50%)';
        label.style.fontSize = '12px';
        label.style.fontWeight = 'bold';
        label.style.color = '#333';
        label.innerText = label.dataset.label;
    });
}

const hideOpenMonthsEl = document.querySelector('.js-hide-open-months');

if (hideOpenMonthsEl) {
    const openRows = document.querySelectorAll('.js-open');

    hideOpenMonthsEl.addEventListener('change', () => {
        openRows.forEach((row) => {
            row.classList.toggle('hidden');
        });
    });
}